import React, { useState } from "react";
import Head from "next/head";
import { GetUser } from "graphql/queries";
import Feed from "components/feedComponents/Feed";
import { AmplifyConfigure } from "utility/amplify";
import graphqlClient from "graphql/apollo-client";
import NoUserFoundScreen from "components/feedComponents/NoUserFoundScreen";
import { generateUserAvatarUrl } from "utility";
import Layout from "components/Layout";
import Navbar from "components/userComponents/Navbar";
import ShareLinksModal from "components/modals/ShareLinksModal";

export default function Index({ metaTags, user }) {
  const [shareLinksModal, setShareLinksModal] = useState(false);

  if (!user) return <NoUserFoundScreen />;

  return (
    <>
      <Head>
        <meta property="og:url" content={metaTags.url} key="ogurl" />
        <meta property="og:site_name" content="Snacktime" key="ogsitename" />
        <meta
          property="og:image"
          itemProp="image"
          content={metaTags.image}
          key="ogimage"
        />
        <meta
          property="og:image:alt"
          content={metaTags.title}
          key="ogimagealt"
        />
        <meta property="og:title" content={metaTags.title} key="ogsitename" />
        <meta property="og:type" content="website" key="ogtype" />
        <meta
          property="og:description"
          content={metaTags.description}
          key="ogdesc"
        />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:site"
          content={process.env.NEXT_PUBLIC_SNACKTIME_TWITTER_USERNAME}
        />
        <meta name="twitter:title" content={metaTags.title} />
        <meta name="twitter:description" content={metaTags.description} />
        <meta name="twitter:image" content={metaTags.image} />
        <meta property="twitter:image:alt" content={metaTags.description} />
        <meta
          property="fb:app_id"
          content={process.env.NEXT_PUBLIC_FACEBOOK_APP_ID}
        />
      </Head>
      <ShareLinksModal
        shareUrl={`${process.env.NEXT_PUBLIC_SNACKTIME_APPLINK_URL}/user/${user.username}`}
        title={`Share @${user.username}'s profile`}
        setShareLinksModal={setShareLinksModal}
        shareLinksModal={shareLinksModal}
      />
      <Navbar
        setShareLinksModal={setShareLinksModal}
        shareLinksModal={shareLinksModal}
      />
      <Layout title={metaTags.title}>
        <Feed user={user} setShareLinksModal={setShareLinksModal} />
      </Layout>
    </>
  );
}

export async function getServerSideProps({ res, params }) {
  const { userId } = params;
  AmplifyConfigure();
  const client = graphqlClient;

  const regexExp =
    /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
  const isUserId = regexExp.test(userId);

  const dynamicName = isUserId ? "targetUserId" : "targetUsername";

  const { data: userData } = await client.query({
    query: GetUser,
    variables: { [dynamicName]: userId },
  });

  // User object //
  const user = userData.getUser;

  if (!user) {
    res.statusCode = 404;
    return {
      props: {
        user: null,
      },
    };
  }

  const image = generateUserAvatarUrl({ user });
  const title = `${user.name} (@${user.username}) | Snacktime`;
  const url = `${process.env.NEXT_PUBLIC_SNACKTIME_PUBLIC_WEB_URL}/user/${dynamicName}`;

  const metaTags = {
    image: image || null,
    description: user.profileDescription || "",
    url,
    title,
  };

  return {
    props: {
      metaTags,
      user,
    },
  };
}
